<div class="table-container">
  @if (filteredDataSource.data.length > 0 && !isLoading) {
    <app-tracking-tabs [dataCounts]="dataCounts"></app-tracking-tabs>
  }
  @if (isLoading) {
    <div class="spinner">
      <mat-progress-spinner
        mode="indeterminate"
        diameter="100"
        color="accent"
      ></mat-progress-spinner>
    </div>
  }
  @if (filteredDataSource.data.length === 0 && !isLoading) {
    <div class="inner-table">No data found.</div>
  }
  <div class="table-data">
    @if (filteredDataSource.data.length > 0 && !isLoading) {
      <table
        #outerTable
        mat-table
        #outerSort="matSort"
        [dataSource]="filteredDataSource"
        multiTemplateDataRows
        class="outer-table mat-elevation-z8"
        matSort
      >
        @for (column of columnDefs; track column) {
          <ng-container [matColumnDef]="column.id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ column.label }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element[column.id] }}
              @if (column.id === "complete" && element[column.id] !== "Yes") {
                <mat-icon
                  class="icon"
                  inline
                  (click)="updateCompete(element); $event.stopPropagation()"
                >
                  edit
                </mat-icon>
              }
            </td>
          </ng-container>
        }
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="columnDefs.length">
            @if (element.details?.length) {
              <div
                class="tracking-element-detail"
                [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'"
              >
                @if (expandedElement) {
                  <div class="inner-table mat-elevation-z8">
                    @for (detailsData of element.details; track detailsData) {
                      <div>
                        <mat-form-field>
                          <input
                            matInput
                            (keyup)="applyFilter($event.target.value)"
                            placeholder="Filter"
                          />
                          <span class="structure-name">{{ detailsData.structureName }}</span>
                        </mat-form-field>
                        <table
                          #innerTables
                          mat-table
                          #innerSort="matSort"
                          [dataSource]="detailsData.layerDetails"
                          matSort
                        >
                          @for (innerColumn of innerColumnDefs; track innerColumn) {
                            <ng-container matColumnDef="{{ innerColumn.id }}">
                              <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                                [ngStyle]="getCellStyle(innerColumn)"
                              >
                                {{ innerColumn.label }}
                              </th>
                              <td
                                mat-cell
                                *matCellDef="let element"
                                [ngStyle]="getCellStyle(innerColumn)"
                              >
                                {{ element[innerColumn.id] }}
                              </td>
                            </ng-container>
                          }
                          <tr mat-header-row *matHeaderRowDef="innerColIds"></tr>
                          <tr mat-row *matRowDef="let row; columns: innerColIds"></tr>
                        </table>
                      </div>
                    }
                  </div>
                }
              </div>
            }
            @if (!element.details?.length) {
              <div
                class="tracking-element-detail"
                [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'"
              >
                @if (expandedElement && isDetailsLoading) {
                  <div>
                    <mat-progress-spinner
                      mode="indeterminate"
                      diameter="40"
                      color="accent"
                    ></mat-progress-spinner>
                  </div>
                }
                @if (expandedElement && !isDetailsLoading) {
                  <div class="inner-table mat-elevation-z8">No details available.</div>
                }
              </div>
            }
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="colIds; sticky: true"></tr>
        <tr
          mat-row
          *matRowDef="let element; columns: colIds"
          [class.tracking-element-row]="element"
          [class.tracking-expanded-row]="expandedElement === element"
          [class.complete-class]="element.complete === 'Yes'"
          (click)="toggleRow(element)"
          class="outer-row"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: ['expandedDetail']"
          class="tracking-details-row"
        ></tr>
      </table>
    }
  </div>
  <mat-paginator
    #paginator
    [pageSizeOptions]="[15, 30, 45, 60]"
    showFirstLastButtons
    aria-label="Select page of periodic elements"
  >
  </mat-paginator>
</div>
